import BarekamButton, { SimpleButtons } from "../button";
import { BarekamIcon, IconVariants } from "../icon/barekam-icon";
import React, { useState } from "react";
import { BarekamMenu } from "./styled";

export const ThreeDot = ({ children }: ThreeDotProps) => {
    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);
    const open = !!anchorEl;

    function onThreeDotClick(event: React.MouseEvent<HTMLElement>) {
        setAnchorEl(event.currentTarget);
    }

    function handleThreeDotClose() {
        setAnchorEl(undefined);
    }

    return (
        <>
            <BarekamButton type={SimpleButtons.LINK} onClick={(event) => onThreeDotClick(event)}>
                <BarekamIcon variant={IconVariants.threeDot} />
            </BarekamButton>

            <BarekamMenu anchorEl={anchorEl}
                open={open}
                dir={'left'}
                elevation={0}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                onClick={handleThreeDotClose}
                onClose={handleThreeDotClose}>
                {children}
            </BarekamMenu>
        </>
    )
}

interface ThreeDotProps {
    children: React.ReactElement | React.ReactElement[],
}